// extracted by mini-css-extract-plugin
export default {"container":"pill_container__ORZW5","label":"pill_label__Z9ff-","btn":"pill_btn__V8Pwo"};